var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"web"}),_c('div',{staticClass:"mobile h-screen w-full flex justify-center items-center text-center text-leading text-lg p-6"},[_vm._v(" La plateforme REMA Business n'est accessible que sur les écrans larges, veuillez vous connecter depuis un ordinateur. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }